import { Stack } from "@mui/system";
import { useFormContext } from "react-hook-form";
import { CBAttachmentFieldTypeNames, CBAttachmentFieldTypes, CBDossierKindKeys, IDossierFormValues, ScoreInfo } from "../../../types";
import { useEffect, useState } from "react";
import CBScoreCustomFieldsInfo from "./CBScoreCustomFieldsInfo";

interface CBScoreCustomFieldsProps {
    attachmentIndex: number,
    currentKind: string | null
}

const CBScoreCustomFields = ({attachmentIndex, currentKind}: CBScoreCustomFieldsProps) => {

    const { getValues } = useFormContext<IDossierFormValues>();

    const [orderedFields, setOrderedFields] = useState<ScoreInfo[]>([]);

    useEffect(() => {

        var arr: any[] = [];
        var typeNames: CBAttachmentFieldTypeNames[] = [];
        
        if(currentKind == CBDossierKindKeys.SELFIE) {
            arr = getValues(`attachments.${attachmentIndex}.fields`)?.filter(f => f.type?.name?.includes(CBAttachmentFieldTypeNames.LIVENESS));
            typeNames = [CBAttachmentFieldTypeNames.LIVENESS];
        }
        else {
            arr = getValues(`attachments.${attachmentIndex}.fields`)?.filter(f => f.type?.name?.includes(CBAttachmentFieldTypeNames.DE) || f.type?.name?.includes(CBAttachmentFieldTypeNames.DNS));
            typeNames = [CBAttachmentFieldTypeNames.DE, CBAttachmentFieldTypeNames.DNS];
        }
         
      
        var sor: ScoreInfo[] = [];

        typeNames.forEach((name) => {
            for (var i=0; i < arr.length; i++) {
                const field = arr[i];

                if(!field.type.name?.includes(name)) continue;
                
                for(var j=i+1; j < arr.length; j++ ) {
                    const fieldJ = arr[j];
                    if(fieldJ.type.name?.includes(name)) {
                        if(field.type.type == CBAttachmentFieldTypes.ARRAY_OF_STRING && fieldJ.type.type == CBAttachmentFieldTypes.STRING) {
                            sor.push({
                                name: name,
                                score: field.value || '',
                                value: fieldJ.value || ''
                            })
                        } else if(fieldJ.type.type == CBAttachmentFieldTypes.ARRAY_OF_STRING && field.type.type == CBAttachmentFieldTypes.STRING) {
                            sor.push({
                                name: name,
                                score: fieldJ.value || '',
                                value: field.value || ''
                            })
                        }
                    }
                }

            }
        });
  
        setOrderedFields(sor);
    }, [attachmentIndex, currentKind/*, getValues(`attachments.${attachmentIndex}.fields`)*/])

    return (
        <Stack direction={{md: "row", xs: "column"}} columnGap={1} alignItems={{md: "center", xs: "flex-start"}}>
            {
                orderedFields.map((field, index) => (
                    <CBScoreCustomFieldsInfo
                        key={`cb-attachment-${attachmentIndex}-field-${field.name}-${index}`}
                        field={field}
                        currentKind={currentKind}
                    />
                ))
            }
        </Stack>
    )

}

export default CBScoreCustomFields;